import React from "react";
import { Box, Typography, Link } from "@material-ui/core";

const Annexure1 = () => {
  return (
    <Box
      style={{
        maxWidth: "700px",
        margin: "50px auto",
        padding: "20px",
        lineHeight: "1.6",
      }}
    >
      <Typography variant="body1" style={{ marginBottom: '2rem' }}>
        Dear Sir/Madam,
      </Typography>

      <Typography variant="body1" style={{ marginBottom: '2rem' }}>
        Greetings from ORIX India!
      </Typography>

      <Typography variant="body1" style={{ marginBottom: '2rem' }}>
        We wish to inform that prior to filing a complaint at{" "}
        <strong>Grievance Redressal Cell</strong>, a prospective/existing
        customer must raise his/her concern on the email IDs given below for
        resolution:
      </Typography>

      <ul style={{ marginBottom: "2rem", paddingLeft: "20px" }}>
        <li>
          <Typography variant="body1">
            Loan Against Property / Commercial Vehicle / Any Other Loan:{" "}
            <Link href="mailto:customercare@orixindia.com">
              customercare@orixindia.com
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Lease Business:{" "}
            <Link href="mailto:lease.foreclosure@orixindia.com">
              lease.foreclosure@orixindia.com
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Any other business:{" "}
            <Link href="mailto:customercare@orixindia.com">
              customercare@orixindia.com
            </Link>
          </Typography>
        </li>
      </ul>

      <Typography variant="body1" style={{ marginTop: '2rem' }}>
        Thanks,
      </Typography>
      <Typography variant="body1">ORIX India Customer Service Desk</Typography>
    </Box>
  );
};

export default Annexure1;
